import LayoutDimTablesMenu from "./LayoutDimTablesMenu";
export default LayoutDimTablesMenu;
